import React from "react";
import { useIntl } from 'react-intl';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
// import Loading from './loading';
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import useThemeQuery from '../../graphql/queries/toggle-theme';
// import useConversationsQuery from '../../graphql/queries/conversations';
// import useDateRangeQuery from '../../graphql/queries/date-range';
import SubHeader from "../header/subheader";
import { getAtmosphereReaction, duration, capitalizeFirstLetter } from "../../utils/utils";
// import NotFound from '../../components/conversation/NotFound';
import { conversationsData } from "../../utils/dummyDatas";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3)
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
    // backgroundColor: 'rgb(0,19,44)'
  },
  tableWrapper: {
    overflowX: "auto"
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1
  }
}));


const StyledTableCellHead = withStyles(theme => ({
    root: {
        borderBottom: "1px solid rgba(0, 19, 44)"
      },
    head: {
      backgroundColor: 'rgb(0,19,44)',
      color: 'rgb(88,106,134)'
    }
  }))(TableCell);


export function EnhancedTableHead(props) {
  const {
    theme,
    formatMessage
  } = props;

  return (
    <TableHead>
      <TableRow>
      <StyledTableCellHead
        align="center"
        style={!theme ? {backgroundColor: '#EBF0F7', borderBottom: 'none', fontWeight: 550} : {fontWeight: 550}}
      >
        {"Date"}
      </StyledTableCellHead>
      <StyledTableCellHead
        align="center"
        style={!theme ? {backgroundColor: '#EBF0F7', borderBottom: 'none', fontWeight: 550} : {fontWeight: 550}}
      >
        {formatMessage({id:"app.conversation.topic", defaultMessage: "Main topic"})}
      </StyledTableCellHead>
      <StyledTableCellHead
        align="center"
        style={!theme ? {backgroundColor: '#EBF0F7', borderBottom: 'none', fontWeight: 550} : {fontWeight: 550}}
      >
        {formatMessage({id:"app.conversation.feeling", defaultMessage: "Feeling"})}
      </StyledTableCellHead>
      <StyledTableCellHead
        align="center"
        style={!theme ? {backgroundColor: '#EBF0F7', borderBottom: 'none', fontWeight: 550} : {fontWeight: 550}}
      >
        {formatMessage({id:"app.conversation.touchpoint", defaultMessage: "Client"})}
      </StyledTableCellHead>
      <StyledTableCellHead
        align="center"
        style={!theme ? {backgroundColor: '#EBF0F7', borderBottom: 'none', fontWeight: 550} : {fontWeight: 550}}
      >
        {formatMessage({id:"app.conversation.duration", defaultMessage: "Duration"})}
      </StyledTableCellHead>
      <StyledTableCellHead
        align="center"
        style={!theme ? {backgroundColor: '#EBF0F7', borderBottom: 'none', fontWeight: 550} : {fontWeight: 550}}
      >
        {formatMessage({id:"app.conversation.pattern", defaultMessage: "Agent"})}
      </StyledTableCellHead>
      <StyledTableCellHead
        align="center"
        style={!theme ? {backgroundColor: '#EBF0F7', borderBottom: 'none', fontWeight: 550} : {fontWeight: 550}}
      >
        {"Other topics"}
      </StyledTableCellHead>
      </TableRow>
    </TableHead>
  );
}

export default function Conversations({router}) {
  const classes = useStyles();
  const [dense] = React.useState(false);
  const { data: theme } = useThemeQuery();
  // const { data: dateRange } = useDateRangeQuery();
  // const { loading, data } = useConversationsQuery({ 
  //     // start:  dateRange? dateRange.dateRange.start: "2016-04-01T00:00:00",
  //     start:  "2016-05-01",
  //     dateCompareType: "LAST_7_DAYS",
  //     timezone:  "Europe/Paris",
  //     size: 10,
  //     page: 1,
  //     way: "DESC"
  // });

  // console.log("TCL: Conversations -> data", data)

  const { formatMessage } = useIntl();

  // if (loading) return <Loading />;

  // if (!data || (data && !data.conversations)) return <NotFound formatMessage={formatMessage}  theme={theme && theme.theme} />;

  // const row2 = topic ? dataTopic : data.conversations.items;

  const handleClickRow = (event, id) => {
    router.push(`/conversations/${id}`);
  };


  const StyledTableRow = withStyles(theme => ({
    root: {
      backgroundColor: "rgb(11,36,62)",
        "&:first-child th": {
          borderTopLeftRadius: 15
        },
        "&:first-child td+td+td+td+td+td": {
          borderTopRightRadius: 15
        },
        "&:last-child th": {
          borderBottomLeftRadius: 15,
          borderBottom: 'none'
        },
        "&:last-child td+td+td+td+td+td": {
          borderBottomRightRadius: 15,
        },
        cursor: 'pointer'
    }
  }))(TableRow);
  

  const StyledTableCell = withStyles(theme => ({
    root: {
        borderBottom: "1px solid rgba(0, 19, 44)",
        paddingTop: 20, 
        paddingBottom: 20,
        "&:first-child th": {
          borderBottom: "none"
        },
        "&:first-child td+td+td+td+td+td": {
          borderBottom: "none"
        },
      },
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white
    },
    body: {
      fontSize: 16,
      color: 'rgb(255,255,255)',
    }
  }))(TableCell);

  return (
    <div className={classes.root}>
      {!conversationsData.topic && <SubHeader title={formatMessage({id:"app.subHeader.conversation.list", defaultMessage: "Latest conversations"})} theme={theme && theme.theme} forms={true} />}
        <div className={classes.tableWrapper}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              theme={theme && theme.theme}
              formatMessage={formatMessage}
            />
            <TableBody >
              {[...conversationsData.conversations, ...conversationsData.conversations].map((row, index) => {
                  return (
                    <StyledTableRow
                      tabIndex={-1}
                      key={row.conversationId + '' + index}
                      onClick={event => handleClickRow(event, row.conversationId)}
                      style={!(theme && theme.theme) ? {backgroundColor: '#fff', }: null}
                    >
                      <StyledTableCell
                        component="th"
                        id={row.id}
                        scope="row"
                        align="center"
                        width="5%"
                        style={!(theme && theme.theme) ? { borderBottom: "1px solid #D4DBE3"}:null}
                      >
                        <Typography style={{color: "#85919D"}}>
                            {row.createdAt + ' ago'}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell 
                        width="5%"
                        align="center"
                        style={!(theme && theme.theme) ? {borderBottom: "1px solid #D4DBE3"}:null}
                      >
                        <Typography 
                          style={!(theme && theme.theme) ? { color: '#000', fontWeight: 550 } : {fontWeight: 550}}
                        >
                          {capitalizeFirstLetter(row.categorization.mainTopic)}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell 
                        align="center"
                        width="5%"
                        style={!(theme && theme.theme) ?{borderBottom: "1px solid #D4DBE3"}:null}
                      >
                        <Box>
                            <img src={getAtmosphereReaction(row.atmosphere.sentiment)} alt="smiley" />
                        </Box>
                      </StyledTableCell>
                      <StyledTableCell 
                        align="center"
                        width="5%"
                        style={!(theme && theme.theme) ?{borderBottom: "1px solid #D4DBE3"}:null}
                      >
                        <Typography 
                          style={!(theme && theme.theme) ? { color: '#364653', fontWeight: 500 } : {fontWeight: 500}}
                        >
                            {row.userId}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell 
                        width="5%"
                        align="center"
                        style={!(theme && theme.theme) ?{borderBottom: "1px solid #D4DBE3"}:null}
                      >
                        <Typography 
                          style={!(theme && theme.theme) ? { color: '#000', fontWeight: 550 } : {fontWeight: 550}}
                        >
                            {duration(row.duration)}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell 
                        width="8%"
                        align="center"
                        style={!(theme && theme.theme) ?{borderBottom: "1px solid #D4DBE3"}:null}
                      >
                        <Typography 
                          style={!(theme && theme.theme) ? { color: '#364653', fontWeight: 500 } : {fontWeight: 500}}
                        >
                            {row.agentId}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell 
                        width="8%"
                        align="left"
                        style={!(theme && theme.theme) ?{borderBottom: "1px solid #D4DBE3"}:null}
                      >
                        <Box>
                          { row.categorization.topics.map(t => {
                              return (
                                <Box key={t.topicId}>
                                  <Typography 
                                    style={!(theme && theme.theme) ? { color: '#364653', fontWeight: 500 } : {fontWeight: 500}}
                                  >
                                      {'- '+capitalizeFirstLetter(t.name)}
                                  </Typography>
                                </Box>
                              )
                            })
                          }
                        </Box>
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
            </TableBody>
          </Table>
        </div>
    </div>
  );
}



